<div class="dx-card padding-content">
    <dx-toolbar #toolbar>
        <dxi-item
            location="before"
            widget="dxButton"
            [disabled]="isDataLoading"
            [options]="exportExcelButtonOptions"
        ></dxi-item>
        <dxi-item
            location="center"
            widget="dxCheckBox"
            [disabled]="isDataLoading"
            [options]="hideDiscontinuedProductCheckBoxOptions"
        ></dxi-item>
        <dxi-item widget="dxButton" location="center" locateInMenu="never">
            <div *dxTemplate>
                @if (discontinuedItemNum > 0 && !isDataLoading) {
                <div>
                    <b>({{ discontinuedItemNum }}&nbsp;items)</b>
                </div>
                }
            </div>
        </dxi-item>
        <dxi-item widget="dxButton" location="after" locateInMenu="never">
            <div *dxTemplate style="margin-right: 20px">
                {{ markedCount | formatNumber : 0 }} /
                {{ pricelistSource.length | formatNumber : 0 }} Marked ({{
                    markedPct | formatNumber : 2
                }}%)
            </div>
        </dxi-item>
        <dxi-item
            location="after"
            widget="dxButton"
            [disabled]="isDataLoading"
            [options]="refreshInventoryButtonOptions"
        ></dxi-item>
    </dx-toolbar>
    <dx-data-grid
        #dataGrid
        [dataSource]="pricelistSource"
        keyExpr="pid"
        [focusedRowEnabled]="false"
        [columnAutoWidth]="false"
        [allowColumnResizing]="true"
        [hoverStateEnabled]="true"
        (onCellDblClick)="onCellDblClick($event)"
    >
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-builder> </dxo-filter-builder>
        <dxo-filter-builder-popup [width]="400" title="Inventory Filter">
        </dxo-filter-builder-popup>
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column
            [width]="120"
            caption="Updated"
            [calculateCellValue]="getItemLastUpdated"
            ><dxo-format formatter="formatLastUpdated"> </dxo-format
        ></dxi-column>
        <dxi-column dataField="sku" caption="SKU" [width]="120"></dxi-column>
        <dxi-column
            dataField="title"
            caption="Product Title"
            [minWidth]="120"
            cellTemplate="titleTemplate"
        ></dxi-column>
        <dxi-column
            dataField="price"
            [width]="120"
            caption="Price"
            dataType="number"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="sell"
            [width]="120"
            caption="Sold"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            dataField="remain"
            [width]="120"
            caption="Remain"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            caption="Marked"
            [width]="80"
            alignment="center"
            dataField="isMarked"
            dataType="boolean"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'priceTemplate'">
            {{ cellData.value | formatNumber : 2 }}
        </div>
        <div *dxTemplate="let cellData of 'numTemplate'">
            {{ cellData.value | formatNumber : 0 }}
        </div>
        <div *dxTemplate="let cellData of 'titleTemplate'">
            <a
                [href]="`https://a.lnwstore.com/arduino4/inventory/product/${cellData.data.pid}/`"
                target="_blank"
                (click)="$event.stopPropagation()"
                [title]="cellData.value"
                class="grid-link-ellipsis"
            >
                {{ cellData.value }}
            </a>
        </div>
        <dxo-selection mode="none"></dxo-selection>
    </dx-data-grid>
</div>
